export default __webpack_public_path__ + "static/media/star.b2bda771.svg";